import { postApi } from "./helpers/apiMethods";

export const logout = async (accessToken: string): Promise<void> => {
  await postApi("/v1/auth/logout", { accessToken });
};
